import NetsQrIdeationLayout from './nets_qr_ideation_layout.jsx'

const NetsQrIdeationPage = () => {
  return (
      <NetsQrIdeationLayout />
  );
};

export default NetsQrIdeationPage;